const footerLinks = {
  热门平台: ['红桃视频', '樱桃视频', '茄子视频', '糖心视频'],
  内容分类: ['高清电视剧', '热门短剧', '综艺娱乐', '电影大片', '古装剧场', '悬疑推理'],
  关于我们: ['平台介绍', '更新日志', '投稿合作', '常见问题'],
  用户服务: ['使用指南', '播放帮助', '意见反馈', '商务合作'],
};

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-200/80">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="py-12 md:py-16">
          <div className="grid grid-cols-2 md:grid-cols-5 gap-8">
            <div className="col-span-2 md:col-span-1">
              <a href="#hero" className="flex items-center gap-2 mb-4 no-underline">
                <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                  <i className="ri-play-circle-fill text-background-50 text-xl"></i>
                </div>
                <span className="text-lg font-bold text-background-50 whitespace-nowrap">
                  桔子视频
                </span>
              </a>
              <p className="text-xs text-background-400 leading-relaxed mb-4">
                桔子视频聚合红桃视频、樱桃视频、茄子视频、糖心视频等热门视频平台内容，
                提供免费在线观看高清电视剧全集，不缓冲流畅播放，视频大全尽在掌握。
              </p>
            </div>

            {Object.entries(footerLinks).map(([title, links]) => (
              <div key={title}>
                <h3 className="text-sm font-bold text-background-50 mb-3 whitespace-nowrap">
                  {title}
                </h3>
                <ul className="space-y-2">
                  {links.map((link) => (
                    <li key={link}>
                      <a
                        href="#hero"
                        className="text-xs text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap"
                      >
                        {link}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-10 pt-8 border-t border-background-400/20">
            <div className="mb-4">
              <h3 className="text-sm font-bold text-background-50 mb-3">合作伙伴</h3>
              <p className="text-xs text-background-500">更多合作伙伴持续加入中，敬请期待</p>
            </div>
          </div>
        </div>

        <div className="py-5 border-t border-background-400/20 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2026 桔子视频 · 全网视频聚合导航平台 · 所有内容版权归原平台所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-xs text-background-500 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">
              回到顶部
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}